import { render, staticRenderFns } from "./ItensWarehouseView.vue?vue&type=template&id=921bf2d6&scoped=true"
import script from "./ItensWarehouseView.vue?vue&type=script&lang=js"
export * from "./ItensWarehouseView.vue?vue&type=script&lang=js"
import style0 from "./ItensWarehouseView.vue?vue&type=style&index=0&id=921bf2d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921bf2d6",
  null
  
)

export default component.exports